import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SendService } from '@service/send/send.service';
import { OwnerService } from '@service/owner/owner.service';
import { TenantService } from '@service/tenant/tenant.service';
import { CustomerService } from '@service/customer/customer.service';
import { PromotionService } from '@service/promotion/promotion.service';
import { SubdivisionService } from '@service/subdivision/subdivision.service';
import { ProspectionService } from '@service/prospection/prospection.service';
import { EmitterService } from '@service/emitter/emitter.service';
import { Setting } from '@model/setting';
import Swal from 'sweetalert2/dist/sweetalert2.js';

interface CategoryOption {
  value: string;
  label: string;
  disabled?: boolean;
}

interface CategoryConfig {
  value: string;
  label: string;
  loader?: () => any;
  setTexte?: string;
}

@Component({
  selector: 'app-send-compose',
  templateUrl: './send-compose.component.html',
  styleUrls: ['./send-compose.component.scss']
})
export class SendComposeComponent implements OnInit {

  @Input() setting: Setting;
  @Output() messageSent = new EventEmitter<any>();

  form: FormGroup;
  submit: boolean = false;
  nbMail: number = 0;
  Emails: any[] = [];
  typageRow: CategoryOption[] = [];
  categorieRow: any[] = [];
  visible: string = null;
  textePersonne: string = '';
  prospectsRow: any[] = [];
  wordCount: number = 0;
  maxSms: number = 160;

  typeRow = [
    { value: 'MAIL', label: 'Mail' },
    { value: 'SMS', label: 'Sms' }
  ];

  personalites = [
    { value: '', label: 'Sélectionnez une personalisation', disabled: true },
    { value: 'PROPRIÉTAIRE', label: 'Bailleurs', disabled: false },
    { value: 'LOCATAIRE', label: 'Locataires', disabled: false },
    { value: 'CLIENT', label: 'Clients', disabled: false },
    { value: 'PROSPECT', label: 'Prospects', disabled: false },
    { value: 'DEFINIR', label: 'Définir le ou les adresse(s) mail(s)', disabled: false }
  ];

  private categoryConfig: Record<string, CategoryConfig[]> = {
    'PROPRIETAIRE': [
      { value: 'TOUT_PROPRIETAIRE', label: 'Tout les bailleurs' },
      { value: 'DEFINIR_PROPRIETAIRE', label: 'Un ou plusieurs bailleurs(s)' }
    ],
    'CLIENT': [
      { value: 'TOUT_CLIENT', label: 'Tout les clients' },
      { value: 'DEFINIR_CLIENT', label: 'Un ou plusieurs client(s)' },
      { value: 'TOUT_PROMOTION', label: 'Tout les clients d\'une promotion' },
      { value: 'TOUT_LOTISSEMENT', label: 'Tout les clients d\'un lotissement' },
      { value: 'IMPAYÉ', label: 'À tous les clients qui ont un impayé' }
    ],
    'LOCATAIRE': [
      { value: 'TOUT_LOCATAIRE', label: 'Tout les locataires' },
      { value: 'DEFINIR_LOCATIAIRE', label: 'Un ou plusieurs locataire(s)' },
      { value: 'LOCATIAIRE_IMPAYE', label: 'A tous les locataires qui ont un impayé' },
      { value: 'LOCATIAIRE_PROPRIETAIRE', label: 'Tout les locataires d\'un bailleurs' }
    ],
    'PROSPECT': [
      { value: 'TOUT_PROSPECT', label: 'Tout les prospects' },
      { value: 'DEFINIR_PROSPECT', label: 'Un ou plusieurs prospect(s)' },
      { value: 'ETAT_PROSPECT', label: 'Les prospects qui ont un etat' }
    ]
  };

  constructor(
    private fb: FormBuilder,
    private emitter: EmitterService,
    private sendService: SendService,
    private ownerService: OwnerService,
    private tenantService: TenantService,
    private customerService: CustomerService,
    private promotionService: PromotionService,
    private prospectionService: ProspectionService,
    private subdivisionService: SubdivisionService
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    this.form = this.fb.group({
      id: [null],
      uuid: [null],
      type: ['MAIL', [Validators.required]],
      destinataire: [null, [Validators.required]],
      objet: [null],
      nombre: [1],
      content: [null, [Validators.required]],
      personalise: [null],
      categorie: [null],
      email: [null]
    });
    this.nbMail = 0;
    this.wordCount = 0;
  }

  get f() { return this.form.controls; }

  get smsPartsCount(): number {
    if (this.wordCount <= 160) return 1;
    return Math.ceil(this.wordCount / 153);
  }

  get smsAlertClass(): string {
    if (!this.setting) return 'alert-secondary';
    const nbr = this.setting.nbrSms;
    if (nbr >= 701) return 'alert-success';
    if (nbr >= 401) return 'alert-primary';
    if (nbr >= 101) return 'alert-warning';
    return 'alert-danger';
  }

  get smsAlertMessage(): string {
    if (!this.setting) return '';
    const nbr = this.setting.nbrSms;
    if (nbr >= 701) return `Vous disposez de ${nbr} SMS.`;
    if (nbr >= 401) return `Vous disposez encore de ${nbr} SMS.`;
    if (nbr >= 101) return `Vous disposez maintenant de ${nbr} SMS. Pensez déjà à vous recharger !`;
    if (nbr > 0) return `Attention ! Vous disposez maintenant de ${nbr} SMS. Veuillez vous approcher de votre fournisseur afin de vous créditer !`;
    return `Attention ! Vous disposez d'aucun SMS. Veuillez vous approcher de votre fournisseur afin de vous créditer !`;
  }

  countWords(): void {
    this.wordCount = this.f.content.value ? this.f.content.value.length : 0;
  }

  onType(): void {
    this.f.objet.reset();
    this.f.email.reset();
    this.f.content.reset();
    this.f.categorie.reset();
    this.f.personalise.reset();
    this.f.destinataire.reset();
    this.f.personalise.setValue('');
    this.wordCount = 0;
  }

  onChangePersonalite(type: string): void {
    this.nbMail = 0;
    this.f.categorie.setValue(null);
    this.visible = null;
    this.typageRow = [];

    const config = this.categoryConfig[type];
    if (config) {
      this.typageRow = [
        { value: null, label: 'Sélectionnez une catégorie', disabled: true },
        ...config.map(c => ({ value: c.value, label: c.label, disabled: false }))
      ];
    } else if (type === 'DEFINIR') {
      this.f.destinataire.reset();
    }
  }

  onChangeCategorie(type: string): void {
    this.nbMail = 0;
    this.visible = type;
    this.f.email.reset();

    switch (type) {
      case 'IMPAYE':
        this.customerService.getList('IMPAYE', null, 'ALL').subscribe((res: any) => this.onSearch(res, 'CLIENT'));
        break;
      case 'TOUT_CLIENT':
        this.customerService.getList().subscribe((res: any) => this.onSearch(res, 'CLIENT'));
        break;
      case 'TOUT_LOCATAIRE':
        this.tenantService.getList(null, 'ALL').subscribe((res: any) => this.onSearch(res, 'LOCATAIRE'));
        break;
      case 'TOUT_PROSPECT':
        this.prospectionService.getList(null, null, null, 'ALL').subscribe((res: any) => this.onSearch(res, 'PROSPECT'));
        break;
      case 'DEFINIR_PROSPECT':
        this.textePersonne = 'Sélectionnez le ou les prospect(s)';
        this.prospectionService.getList(null, null, null, 'ALL').subscribe((res: any) => this.categorieRow = res);
        break;
      case 'DEFINIR_CLIENT':
        this.textePersonne = 'Sélectionnez le ou les client(s)';
        this.customerService.getList(null, null, 'ALL').subscribe((res: any) => this.categorieRow = res);
        break;
      case 'TOUT_PROMOTION':
        this.textePersonne = 'Sélectionnez la promotion';
        this.promotionService.getList().subscribe((res: any) => this.categorieRow = res);
        break;
      case 'TOUT_LOTISSEMENT':
        this.subdivisionService.getList('ALL').subscribe((res: any) => this.categorieRow = res);
        break;
      case 'TOUT_PROPRIETAIRE':
        this.ownerService.getList('ALL').subscribe((res: any) => this.onSearch(res, 'PROPRIETAIRE'));
        break;
      case 'DEFINIR_LOCATIAIRE':
        this.textePersonne = 'Sélectionnez le ou les locataire(s)';
        this.tenantService.getList(null, 'ALL').subscribe((res: any) => this.categorieRow = res);
        break;
      case 'DEFINIR_PROPRIETAIRE':
        this.textePersonne = 'Sélectionnez le ou les bailleurs(s)';
        this.ownerService.getList('ALL').subscribe((res: any) => this.categorieRow = res);
        break;
      case 'LOCATIAIRE_PROPRIETAIRE':
        this.textePersonne = 'Sélectionnez le bailleurs';
        this.ownerService.getList('ALL').subscribe((res: any) => this.categorieRow = res);
        break;
      case 'ETAT_PROSPECT':
        this.textePersonne = 'Sélectionnez l\'etat';
        break;
      case 'LOCATIAIRE_IMPAYE':
        this.textePersonne = 'État';
        this.categorieRow = [
          { value: 'ENTREE', label: 'Entrée' },
          { value: 'LOYER', label: 'Loyer' },
          { value: 'PENALITY', label: 'Pénalité' }
        ];
        break;
    }
  }

  onChangeTiers(uuid: string, type: string): void {
    this.nbMail = 0;
    if (!uuid) return;

    switch (type) {
      case 'TOUT_PROMOTION':
        this.customerService.getList('PROMOTION', uuid).subscribe((res: any) => this.onSearch(res, 'CLIENT'));
        break;
      case 'TOUT_LOTISSEMENT':
        this.customerService.getList('LOTISSEMNT', uuid).subscribe((res: any) => this.onSearch(res, 'CLIENT'));
        break;
      case 'LOCATIAIRE_PROPRIETAIRE':
        this.tenantService.getList(uuid).subscribe((res: any) => this.onSearch(res, 'LOCATAIRE'));
        break;
      case 'LOCATIAIRE_IMPAYE':
        this.tenantService.getList(null, null, uuid).subscribe((res: any) => this.onSearch(res, 'LOCATAIRE'));
        break;
      case 'ETAT_PROSPECT':
        this.prospectionService.getList(null, uuid).subscribe((res: any) => {
          res.forEach((item: any) => this.prospectsRow.push(item));
          this.onSearch(this.prospectsRow, 'PROSPECT');
        });
        break;
    }
  }

  onSearch(row: any[], type: string): void {
    let dataEmails = [];
    const isMail = this.f.type.value === 'MAIL';

    if (type === 'PROPRIETAIRE' || type === 'LOCATAIRE' || type === 'PROSPECT') {
      dataEmails = row.map(item => isMail ? item?.email : item?.telephone);
    } else if (type === 'CLIENT') {
      dataEmails = row.map(item => isMail ? item?.user?.email : item?.telephone);
    }

    this.Emails = dataEmails;
    this.f.destinataire.setValue(dataEmails);
    this.nbMail = this.Emails.length;
  }

  definirPersonne(email: any): void {
    this.f.destinataire.setValue(email);
    if (email !== null) {
      this.nbMail = email.length;
    }
  }

  onDestinataire(input: any): void {
    let text = input.target.value.trim();
    if (text.includes(',') || text.includes(' ')) {
      let elements = text.split(/,|\s+/).filter(e => e.length > 0);
      this.f.destinataire.setValue(elements);
      this.nbMail = elements.length;
    } else {
      this.f.destinataire.setValue([text]);
      this.nbMail = 1;
    }
  }

  onSubmit(): void {
    this.submit = true;
    if (!this.form.valid) return;

    const typeLabel = this.f.type.value === 'MAIL' ? 'mail' : 'SMS';

    Swal.fire({
      title: 'Confirmer l\'envoi',
      text: `Vous allez envoyer ce ${typeLabel} à ${this.nbMail} destinataire(s). Confirmer ?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Envoyer',
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.isConfirmed) {
        this.doSend();
      }
    });
  }

  private doSend(): void {
    this.sendService.add(this.form.getRawValue()).subscribe(res => {
      if (res?.status === 'success') {
        this.emitter.emit({ action: 'SEND_ADD', payload: res?.data });
        Swal.fire({
          title: 'Succès',
          text: res?.message || 'Message envoyé avec succès',
          icon: 'success',
          timer: 2000,
          showConfirmButton: false
        });
        this.messageSent.emit(res?.data);
        this.initForm();
        this.f.type.setValue('MAIL');
        this.f.personalise.setValue('');
        this.submit = false;
      }
    }, error => {});
  }
}
